import {
  SET_PAGE_CONTENT,
  SET_ACTIVE_STEP,
  SET_SIGNUP_ROUTES,
  SET_NEXT_ACTION,
  SET_AB_TEST_TRACKED,
} from './constants'

import { StepRoute } from '@/types/routes'
import { Step } from '@/types/partnerConfig'

const setActiveStepIndex = (activeStepIndex: number) => ({
  type: SET_ACTIVE_STEP,
  payload: { activeStepIndex },
})

const setPageContent = (pageContent: Step) => ({
  type: SET_PAGE_CONTENT,
  payload: { pageContent },
})

const setSignupRoutes = (signupRoutes: StepRoute[]) => ({
  type: SET_SIGNUP_ROUTES,
  payload: { signupRoutes },
})

const setNextAction = (nextAction: () => void) => ({
  type: SET_NEXT_ACTION,
  payload: { nextAction },
})

const setAbTestTracked = (tracked: boolean) => ({
  type: SET_AB_TEST_TRACKED,
  payload: tracked,
})

export {
  setActiveStepIndex,
  setPageContent,
  setSignupRoutes,
  setNextAction,
  setAbTestTracked,
}
